export enum INTERNAL_POST_LINK_SELECTION_MODE {
    inline = 'inline',
    modal = 'modal',
}

export default INTERNAL_POST_LINK_SELECTION_MODE;
